// Module
var code = "<div class=\"gc-control\"> {{ tooltipEl }} </div>";
// Exports
export default code;